import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSectionComponentBase } from '../../../ProductSectionComponentBase';
import { ProductSectionComponent } from '../../product-section';
import { ProductLinksComponent } from '../product-links';

@Component({
  selector: 'ideal-product-section-links',
  imports: [ProductSectionComponent, ProductLinksComponent],
  standalone: true,
  templateUrl: './product-section-links.component.html',
  styleUrl: './product-section-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hasContent() ? undefined : "none"',
  },
})
export class ProductSectionLinksComponent extends ProductSectionComponentBase {}
